




































































































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { isNull } from 'lodash';
import PaginationInterface from '@core/interfaces/pagination-interface';
import { BPCDisplayConfig } from '@core/interfaces/bpc-display-config';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import TableWrapper from '@shared/layouts/wrappers/table/table-wrapper.vue';
import GridMock from '@shared/components/mocks/grid-mock/grid-mock.vue';
import moment from 'moment';
import ActivityCardV2 from '@activities/components/cards/activity-card-v2/activity-card-v2.vue';
import { Activity, ActivityExtendedFilters } from '@activities/interfaces/activity';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import SearchInput from '@shared/components/forms/inputs/search-input.vue';
import { activityFilters } from '@/config/activities';

import { mixins } from 'vue-class-component';
import ExtendedFiltersMixin from '@shared/components/tables/abstract-table/extended-filters-mixin';
import { v4 as uuidv4 } from 'uuid';
import CreateBasicActivityForm from '@activities/components/forms/create-basic-activity-form/create-basic-activity-form.vue';
import ActivityFormV2 from '@activities/components/forms/activity-form-v2/activity-form-v2.vue';
import ActivityExtendedFilterForm from '../forms/activity-extended-filter-form.vue';
import TrainingCard from '@activities/components/cards/training-card/training-card.vue';
import CompetitionCard from '@activities/components/cards/competition-card/competition-card.vue';

@Component({
  name: 'bpc-activities-list',
  components: {
    'bpc-content-wrapper': ContentWrapper,
    'bpc-table-wrapper': TableWrapper,
    'bpc-grid-mock': GridMock,
    'bpc-activity-card-v2': ActivityCardV2,
    'bpc-training-card': TrainingCard,
    'bpc-competition-card': CompetitionCard,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-entity-select': EntitySelect,
    'bpc-multi-select': MultiSelect,
    'bpc-search-input': SearchInput,
    'bpc-create-basic-activity-form': CreateBasicActivityForm,
    'bpc-activity-form-v2': ActivityFormV2,
    'bpc-activity-extended-filter-form': ActivityExtendedFilterForm,
  },
})
export default class ActivitiesList extends mixins(ExtendedFiltersMixin) {
  declare $refs: ExtendedFiltersMixin['$refs'] & {
    softDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
  };
  // PROPS
  @Prop({ type: Object }) readonly initialFilters: {
    search: string;
    status: string;
    period: string;
    activity_type: string;
    responsible_ids: number[];
  };
  @Prop({ type: String }) readonly actionsPortalTarget: string;
  @Prop({ type: Boolean, default: false }) readonly hideFilterType;
  @Prop({ type: String, default: null }) readonly blockedType;
  @Prop({ type: String }) readonly withUrlParams: boolean;
  @Prop({ type: String, default: 'bpc-activity' }) readonly customFilterEntityName: string;

  // DATA
  loading: boolean = false;
  urlParams: Record<string, string> = {};
  config: BPCDisplayConfig = null;
  activityItems: Activity[] = [];
  submittedSearch = '';
  selectedStatus = '';
  selectedPeriod = '';
  selectedType = '';
  selectedResponsibles = [];

  // NOTE: EXTENDED FILTERS
  selectedCategoryId = null; // activity_category_id
  selectedDateFrom = ''; // start_date_from
  selectedDateTo = ''; // start_date_to
  selectedContactId = null; // contact_id
  selectedDisciplineId = null; // disciplines__id
  selectedAllowMultipleEnrollment = null; // allow_multiple_enrollment
  selectedPublished = null; // published

  entityName = 'bpc-activity';

  pageOptions: number[] = [5, 10, 15, 20, 50, 100, 200];
  pagination: PaginationInterface = {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    from: 0,
    to: 0,
    total: 0,
  };

  gridCols = {
    sm: 12,
    md: 6,
    lg: 4,
  };

  formModel: Partial<Activity> = {};
  timestamp = moment().unix();
  showCreateActivityModal: boolean = false;
  showEditActivityModal: boolean = false;

  // LIFECYCLE

  // created() {}
  mounted() {
    this.initializeFiltersFromProperties();
    this.initializeValuesFromUrlParams();
    this.getActivitiesIfStopChanging();
  }
  // updated(){}
  // destroyed(){}

  // COMPUTED
  get filtersConfig() {
    return activityFilters;
  }

  get createButtonLabel() {
    return this.blockedType
      ? this.$t(`global.actions.create_new_${this.blockedType}`)
      : this.$t('global.actions.create_new_activity');
  }

  get formCancelPortalTarget(): string {
    return `activity-form-cancel-portal-target-${this.timestamp}`;
  }

  get formActionsPortalTarget(): string {
    return `activity-form-actions-portal-target-${this.timestamp}`;
  }

  get editFormCancelButtonPortalTarget(): string {
    return `edit-form-cancel-portal-target-${this.timestamp}`;
  }

  get editFormSaveButtonPortalTarget(): string {
    return `edit-form-actions-portal-target-${this.timestamp}`;
  }

  get changeDetectorStr(): string {
    return [
      this.pagination.per_page,
      this.pagination.current_page,
      this.submittedSearch,
      this.selectedStatus,
      this.selectedPeriod,
      this.selectedType,
      ...this.selectedResponsibles,
      // Extended
      this.selectedCategoryId,
      this.selectedDateFrom,
      this.selectedDateTo,
      this.selectedContactId,
      this.selectedDisciplineId,
      this.selectedAllowMultipleEnrollment,
      this.selectedPublished,
    ].join('--');
  }

  get softDeleteConfirmationModalConfig(): ConfirmationModalConfig {
    const entityName = 'bpc-activity';
    return {
      id: entityName + '-soft-delete-modal',
      title: this.$t('global.modals.soft-delete.title', {
        entityName: this.$t('global.models.' + entityName + '.name'),
        entityPluralName: this.$t('global.models.' + entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + entityName + '.thisPluralName'),
      }),
      body: this.$t('global.modals.soft-delete.body', {
        entityName: this.$t('global.models.' + entityName + '.name'),
        entityPluralName: this.$t('global.models.' + entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + entityName + '.thisPluralName'),
      }) as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.move_to_trash') as string,
      acceptButtonVariant: 'danger',
    };
  }

  get createActivityModalId() {
    return uuidv4();
  }

  get editActivityModalId() {
    return uuidv4();
  }

  // METHODS
  clickOnView(item) {
    let routeName = 'admin-activities-manage';

    if (item.activity_type === 'training') {
      routeName = 'admin-club-trainings-management';
    } else if (item.activity_type === 'competition') {
      routeName = 'admin-club-competitions-management';
    }
    const tenant = this.$authService.getSelectedTenant();
    this.$router.push({
      name: routeName,
      params: {
        tenantAlias: tenant.alias,
        id: item.id,
      },
    });
  }

  clickOnViewTraining(item) {
    const routeName = 'admin-club-trainings-management';
    const tenant = this.$authService.getSelectedTenant();
    this.$router.push({
      name: routeName,
      params: {
        tenantAlias: tenant.alias,
        id: item.id,
      },
    });
  }

  clickOnViewCompetition(item) {
    const routeName = 'admin-club-competitions-management';
    const tenant = this.$authService.getSelectedTenant();
    this.$router.push({
      name: routeName,
      params: {
        tenantAlias: tenant.alias,
        id: item.id,
      },
    });
  }

  clickOnCreate() {
    this.showCreateActivityModal = true;
  }

  clickOnClose() {
    this.showCreateActivityModal = false;
    this.formModel = {};
  }

  clickOnEdit(item) {
    const routeName = 'admin-activities-manage';
    const tenant = this.$authService.getSelectedTenant();
    this.$router.push({
      name: routeName,
      params: {
        tenantAlias: tenant.alias,
        id: item.id,
      },
    });
  }

  clickOnCloseEdit() {
    this.showEditActivityModal = false;
    this.formModel = {};
  }

  clickOnSoftDelete(value) {
    if (typeof value === 'object') {
      value = value['id'];
    }
    this.$refs.softDeleteConfirmationModal.onOpenModal(value);
  }

  onActivityCreated(item) {
    this.clickOnView(item.data);
  }

  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.getActivitiesIfStopChanging();
  }

  getActivitiesIfStopChanging() {
    const changeStr = this.changeDetectorStr;
    setTimeout(() => {
      if (changeStr === this.changeDetectorStr) {
        this.getActivities();
      }
    }, 300);
  }

  onExtendedFiltersCleared() {
    this.clearFilters();
    this.initializeFiltersFromProperties();
    this.initializeValuesFromUrlParams();
    this.getActivitiesIfStopChanging();
  }

  clearFilters() {
    this.submittedSearch = '';
    this.selectedStatus = '';
    this.selectedPeriod = '';
    this.selectedType = '';

    // NOTE: EXTENDED FILTERS
    this.selectedCategoryId = null; // activity_category_id
    this.selectedDateFrom = ''; // start_date_from
    this.selectedDateTo = ''; // start_date_to
    this.selectedContactId = null; // contact_id
    this.selectedDisciplineId = null; // disciplines__id
    this.selectedAllowMultipleEnrollment = null; // allow_multiple_enrollment
  }

  initializeFixedFilters() {
    // if (this.fixedFilters.search) {
    //   this.submittedSearch = this.fixedFilters.search;
    // }
    // this.selectedStatus = this.initialFilters?.status || 'active';
    // this.selectedPeriod = this.initialFilters?.period || 'ongoing_upcoming';
    // this.selectedType = this.initialFilters?.activity_type || '';
  }

  initializeFiltersFromProperties() {
    this.submittedSearch = this.initialFilters?.search || '';
    this.selectedStatus = this.initialFilters?.status || 'active';
    this.selectedPeriod = this.initialFilters?.period || 'ongoing_upcoming';
    this.selectedType = this.initialFilters?.activity_type || '';
    this.selectedResponsibles = this.initialFilters?.responsible_ids
      ? [this.initialFilters?.responsible_ids]
      : [];
  }

  initializeValuesFromUrlParams() {
    if (this.withUrlParams) {
      const urlParams = this.getUlrParams();
      this.setFiltersFromObject(urlParams);
    }
  }

  // First call
  async getActivities() {
    this.loading = true;
    const params = this.getQueryParams();
    const url = this.$bpcApiRouteHelper.getEntityPath('bpc-activity');
    const res = await this.$bpcApi.get(url, { params: params }).toPromise();
    this.activityItems = res.data;
    this.pagination = res.meta;
    this.setUrlParams(params);
    this.loading = false;
  }

  getQueryParams() {
    const params = {
      orderBy: 'name',
      orderDirection: 'asc',
      per_page: this.pagination.per_page,
      page: this.pagination.current_page,
      // EXTENDED FILTERS
    };

    if (this.submittedSearch) {
      this.$set(params, 'search', this.submittedSearch);
    }

    if (this.selectedStatus) {
      this.$set(params, 'status', this.selectedStatus);
    }

    if (this.selectedPeriod) {
      this.$set(params, 'period', this.selectedPeriod);
    }

    if (this.selectedType) {
      this.$set(params, 'activity_type', this.selectedType);
    }
    if (this.selectedResponsibles) {
      this.$set(params, 'responsible_ids', this.selectedResponsibles);
    }

    if (this.selectedCategoryId) {
      this.$set(params, 'activity_category_id', this.selectedCategoryId);
    }

    if (this.selectedDateFrom) {
      this.$set(params, 'start_date_from', this.selectedDateFrom);
    }

    if (this.selectedDateTo) {
      this.$set(params, 'start_date_to', this.selectedDateTo);
    }

    if (this.selectedContactId) {
      this.$set(params, 'contact_id', this.selectedContactId);
    }

    if (this.selectedDisciplineId) {
      this.$set(params, 'disciplines__id', this.selectedDisciplineId);
    }

    if (this.selectedAllowMultipleEnrollment) {
      this.$set(params, 'allow_multiple_enrollment', this.selectedAllowMultipleEnrollment);
    }

    if (this.selectedPublished) {
      this.$set(params, 'published', this.selectedPublished);
    }

    return params;
  }

  getUlrParams() {
    const urlQueryParams = JSON.parse(JSON.stringify(this.$route.query), (k, v) => {
      if (!isNaN(v) && !isNull(v)) {
        return parseInt(v);
      }
      return v;
    });
    return {
      ...urlQueryParams,
    };
  }

  setUrlParams(params) {
    this.$emit('query-params-changed', params);
  }

  clickOnReload() {
    this.getActivitiesIfStopChanging();
  }

  onChangeFilter(model = null) {
    this.clearFilters();
    this.initializeFiltersFromProperties();
    this.initializeValuesFromUrlParams();
    this.onExtendedFilterFormSearch(model);
  }

  extendedFilterModel: ActivityExtendedFilters = {
    status: null,
    period: null,
    activity_type: null,
    activity_category_id: null,
    start_date_from: null,
    start_date_to: null,
    contact_id: null,
    disciplines__id: [],
    allow_multiple_enrollment: null,
    published: null,

    orderBy: 'name',
    orderDirection: 'desc',
    per_page: 20,
    page: 1,
  };

  onExtendedFilterFormSearch(model = null) {
    this.clearFilters();
    if (model) {
      this.extendedFilterModel = model;
    }
    this.setFiltersFromObject(this.extendedFilterModel);
  }

  setFiltersFromObject(filterModel) {
    if (filterModel?.search) {
      this.submittedSearch = filterModel?.search;
    }
    if (filterModel?.status) {
      this.selectedStatus = filterModel?.status;
    }
    if (filterModel?.period) {
      this.selectedPeriod = filterModel?.period;
    }
    if (filterModel?.activity_type) {
      this.selectedType = filterModel?.activity_type;
    }

    if (filterModel?.responsible_ids) {
      this.selectedResponsibles = filterModel?.responsible_ids;
    }

    if (filterModel?.activity_category_id) {
      this.selectedCategoryId = filterModel.activity_category_id;
    }
    if (filterModel?.start_date_from) {
      this.selectedDateFrom = filterModel.start_date_from;
    }
    if (filterModel?.start_date_to) {
      this.selectedDateTo = filterModel.start_date_to;
    }
    if (filterModel?.contact_id) {
      this.selectedContactId = filterModel.contact_id;
    }
    if (filterModel?.disciplines__id) {
      this.selectedDisciplineId = filterModel.disciplines__id;
    }
    if (filterModel?.allow_multiple_enrollment) {
      this.selectedAllowMultipleEnrollment = filterModel.allow_multiple_enrollment;
    }
    if (filterModel?.published) {
      this.selectedPublished = filterModel.published;
    }
  }

  onActivitiesExtendedFilterFormToggle() {
    this.extendedFilterModel = this.getQueryParams();
    this.onExtendedFilterFormToggle();
  }
  async onActivitiesCustomFilterFormSave(model = null) {
    this.isSavingCustomFilters = true;

    const filterModel = model ? model : this.extendedFilterModel;
    const customFiltersModel = this.$refs.stdCustomFiltersForm.formModel;
    customFiltersModel.entity = this.customFilterEntityName;
    customFiltersModel.filters = filterModel;

    this.$set(this.$refs.stdCustomFiltersForm, 'formModel', customFiltersModel);

    await this.$refs.stdCustomFiltersForm.saveEntity();
    await this.$refs.customFilterSelector.getCustomFilters();

    this.onCustomFilterFormClose();
  }

  // WATCHERS
  @Watch('changeDetectorStr')
  onChangeDetectorStrChange(val) {
    if (val) {
      this.getActivitiesIfStopChanging();
    }
  }
}
